import { format, parseISO } from "date-fns";

import { sanitizeToISODate } from "../../../lib/itn-ui-kit/data/transformers/sanitizers";

const emptyString = "";

const formattedDate = (value) => {
  if (!value || value === undefined || value === null) {
    return emptyString;
  }
  if (value === "" || value === " ") {
    return emptyString;
  }
  return format(parseISO(value), "M/d/yyyy");
};

const formattedTime = (value) => {
  if (!value || value === undefined || value === null) {
    return emptyString;
  }
  if (value === "" || value === " ") {
    return emptyString;
  }
  return format(parseISO(value), "h:mm aaa");
};

const lineBreakSeparator = () => {
  return "\n";
};

const FormatISODateTime = (date, newLine = false, sep = " ") => {
  const cleanDate = sanitizeToISODate(date);
  return (
    formattedDate(cleanDate).toString() +
    sep +
    (newLine ? lineBreakSeparator() : "") +
    formattedTime(cleanDate).toString()
  );
};

const FormatTimeIn12HourFormat = (time) => {
  if (!time || typeof time !== "string") {
    return "";
  }

  const [hourStr, minuteStr] = time.split(":");
  const hour24 = Number(hourStr);

  if (Number.isNaN(hour24)) {
    return "";
  }

  const hour12 = hour24 % 12 || 12;
  const period = hour24 < 12 ? "am" : "pm";

  return `${hour12}:${minuteStr} ${period}`;
};

export { FormatTimeIn12HourFormat };
export default FormatISODateTime;
